import { addFeaturesOverridesAndLock, isFeatureEnabled } from '@luna/gatekeeper';

import { fetchGatekeeperFeatures } from './GatekeeperApiService';

export async function startGatekeeper() {
    if (!isFeatureEnabled((f) => f.gatekeeper)) {
        addFeaturesOverridesAndLock();
        return;
    }
    const features = await fetchGatekeeperFeatures();
    addFeaturesOverridesAndLock(features);
}
